module.exports = __webpack_public_path__ + "static/media/apple_bag_6.78463b05.png";